(function() {
  "use strict";
  angular.module("marketPlace.social_media_links", []);
})();
